var map = {
	"./img/andalucia/cover.jpg": 50010,
	"./img/basque-country/cover.jpg": 99342,
	"./img/berlin/cover.jpg": 69948,
	"./img/copenhagen/cover.jpg": 18647,
	"./img/portugal/cover.jpg": 55264,
	"./img/slovenia/cover.jpg": 66588,
	"./img/turkey/cover.jpg": 94149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91682;